module.exports = __webpack_public_path__ + "img/00024.d33dc00f.webp";